import React from 'react';
import { BookmarkLink } from '@app/utils/types';
import { Wrapper, Link } from './styles';
import ButtonOutlined from '@components/ButtonOutlined';

interface BookmarkLinksProps {
  bookmarkLinks?: BookmarkLink[];
}

const BookmarkLinks = ({ bookmarkLinks }: BookmarkLinksProps) => {
  if (bookmarkLinks && bookmarkLinks.length === 0) return null;

  return (
    <Wrapper>
      {bookmarkLinks?.map((item, index) => (
        <Link href={item.externalUrl} target="_blank" key={index}>
          <ButtonOutlined title={item.label} padding="10px 30px" />
        </Link>
      ))}
    </Wrapper>
  );
};

export default BookmarkLinks;
